import styled, { css } from 'styled-components';
import { colors, breakpoints } from 'definitions'

// En la home el header flota sobre el video del hero: sale del flujo (fixed) para
// que el video arranque en el tope de la página y arranca transparente. Al
// scrollear pasa a sólido para seguir siendo legible sobre el contenido.
export const HeaderContainer = styled.header`
    display: flex;
    background-color: ${colors.background.white};
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1000;

    ${({ floating }) => floating && css`
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        transition: background-color 300ms ease, box-shadow 300ms ease;
    `}

    ${({ overlay }) => overlay && css`
        background-color: transparent;

        /* Degradé sutil para que el logo y el menú se lean sobre cualquier
           fotograma del video. */
        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 12rem;
            background: linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0.65) 0%,
                rgba(0, 0, 0, 0.45) 60%,
                rgba(0, 0, 0, 0) 100%
            );
            pointer-events: none;
            z-index: -1;
        }
    `}

    ${({ floating, overlay }) => floating && !overlay && css`
        box-shadow: 0 2px 12px rgba(8, 37, 90, 0.12);
    `}

    ${breakpoints.desktop}
    {
        display:flex;
        justify-content: space-between;
        width:100%;
        width:100%;
    }
`;

export const HeaderContentContainer = styled.div`
    width: 124.4rem;

    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content: space-between;
    height: 8rem;

    ${breakpoints.desktop}
    {
        width: 100%;
        justify-content: space-between;
        max-width: 992px;
    }

    ${breakpoints.tablet}
    {
        margin: 0 1rem;
        /* Descontar los márgenes: con width:100% el contenido se salía 2rem
           por derecha y tapaba el ícono de login. */
        width: calc(100% - 2rem);
        justify-content: space-between;
        max-width: 768px;
    }
`;

export const White = styled.div`
    width: 100%;
    height: 8rem;
    background-color: white;
    position: absolute;
    z-index: -20;
    left:0;
`;

// Botón destacado que lleva al sitio del evento. Sobre el video va en versión
// outline blanca; sobre fondo blanco, en azul sólido.
export const EventButton = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;

    padding: 1.1rem 2.4rem;
    border-radius: 50px;

    font-size: 1.4rem;
    font-weight: 700;
    line-height: 1.7rem;
    text-decoration: none;

    transition: background-color 200ms ease, color 200ms ease,
        border-color 200ms ease;

    background-color: ${colors.background.yellowGreen};
    color: ${colors.fonts.white};
    border: 2px solid ${colors.background.yellowGreen};

    &:hover {
        background-color: ${colors.hover.darkBlue};
        border-color: ${colors.hover.darkBlue};
    }

    ${({ overlay }) => overlay && css`
        background-color: transparent;
        color: ${colors.fonts.white};
        border-color: ${colors.fonts.white};

        &:hover {
            background-color: ${colors.fonts.white};
            color: ${colors.fonts.darkGray};
            border-color: ${colors.fonts.white};
        }
    `}

    ${breakpoints.laptop} {
        padding: 0.9rem 1.6rem;
        font-size: 1.2rem;
    }

    ${breakpoints.mobile} {
        padding: 0.8rem 1.2rem;
        font-size: 1.1rem;
    }
`;
